export const SYSTEM_INIT = 'SYSTEM_INIT'
export const SYSTEM_SAVE = 'SYSTEM_SAVE'
export const SYSTEM_UPDATE = 'SYSTEM_UPDATE'
export const SYSTEM_SELECT_TAB = 'SYSTEM_SELECT_TAB'
export const SYSTEM_LOAD_MAPPINGS = 'SYSTEM_LOAD_MAPPINGS'
